import { Contact, InvoiceDTO } from './InvoiceDTO';

export enum IdentityProvider {
  V5 = 'V5',
  V3 = 'V3',
}

type CheckoutType = 'CardholderPresent' | 'CardholderNotPresent';

export class CheckoutCommand {
  constructor(
    invoice: InvoiceDTO,
    authNumber: string,
    email: string,
    invoicePortalUrl: string,
    invoiceApiUrl: string,
    type: CheckoutType
  ) {
    this.type = type;
    const { id, outstandingAmount, contact } = invoice;
    this.amountIncVat = outstandingAmount.amountIncVat;
    this.client = 'invoice-payment-portal';
    this.firstName = contact.firstname;
    this.lastName = contact.surname;
    this.identityProvider = IdentityProvider.V5;
    this.companyName = contact.organisationName;

    switch (type) {
      case 'CardholderNotPresent':
        const url = new URL(window.location.toString());
        url.searchParams.append('transaction', '{id}');

        this.cancelUrl = decodeURI(url.toString());
        this.returnUrl = decodeURI(url.toString());
        this.paymentIdentifier = `${invoice.id}-${authNumber}`;
        this.paymentReference = `${invoice.id}-${authNumber}`.substr(0, 11);
        this.postProcessingWebhook = `${invoiceApiUrl}/payments/process-internal`;
        this.useRedirect = true;
        break;
      case 'CardholderPresent':
        this.email = email;
        this.phoneNumber = contact.phone;
        this.billingAddress = this.mapAddress(contact);
        this.cancelUrl = `${invoicePortalUrl}/invoice/${invoice.id}/${authNumber}`;
        this.returnUrl = `${invoicePortalUrl}/success/${invoice.id}/${authNumber}`;
        this.paymentIdentifier = id.toString();
        this.paymentReference = id.toString().substr(0, 11);
        this.postProcessingWebhook = `${invoiceApiUrl}/payments/process`;
        this.useRedirect = false;
        break;
    }
  }

  useRedirect: boolean;
  type: CheckoutType;
  amountIncVat: number;
  client: string;
  email?: string;
  firstName: string;
  lastName: string;
  paymentReference: string;
  paymentIdentifier: string;
  phoneNumber?: string;
  cancelUrl: string;
  returnUrl: string;
  billingAddress?: Address;
  identityProvider: IdentityProvider;
  postProcessingWebhook: string;
  companyName: string;

  private mapAddress = (contact: Contact) => {
    const { addressLineOne, town, postCode } = contact;
    let lineOne = addressLineOne;
    let lineTwo;

    const index = !!lineOne ? lineOne.indexOf('\r\n') : 0;
    if (index > 0) {
      lineOne = addressLineOne.substring(0, index);
      lineTwo = addressLineOne.substring(index + 2);
    }

    return {
      addressLineOne: lineOne,
      addressLineTwo: lineTwo,
      town: town,
      postcode: postCode,
      country: 'GB',
    };
  };
}

interface Address {
  addressLineOne: string;
  addressLineTwo?: string;
  town: string;
  postcode: string;
  country: string;
}
